import { dashboardRedux } from "./dashboard-redux/DashboardRedux";
import { projectMeetingRedux } from "./dashboard-redux/project-meetings-redux/ProjectMeetingsRedux";
import { createPostRedux } from "./create-post-redux/CreatePostRedux";
import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";
import { loginRedux } from "./login-redux/LoginRedux";
import rootSaga from "../sagas";
import { ProfileRedux } from "./profile-redux/ProfileRedux";
import { blogsRedux } from "./blogs-redux/BlogsRedux";
import { ToasterRedux } from "./toaster-redux/ToasterRedux";
import { CommentRedux } from "./comment-redux/CommentRedux";
import { chatRedux } from "./chat-redux/ChatRedux";
import { helpAndSupportRedux } from "./help-and-support-redux/HelpAndSupportRedux";
import { createProjectRedux } from "./create-project-redux/CreateProjectRedux";
import { exploreRedux } from "./explore-redux/ExploreRedux";
import { homeRedux } from "./home-redux/HomeRedux";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";
import { recommendationRedux } from "./recommendation-redux/RecommendationRedux";
import { reportRedux } from "./help-and-support-redux/reportRedux";
import { notificationsRedux } from "./notification-redux/NotificationsRedux";
import { eventsRedux } from "./events-redux/EventsRedux";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ["recommendationRedux", "chatRedux", "ExploreRedux", "ProfileRedux"],
  blacklist: [
    "Login",
    "CreateProjectRedux",
    "HomeRedux",
    "dashboardRedux",
    "projectMeetingRedux",
    "searchRedux",
    "blogsRedux",
    "toasterRedux",
    "commentRedux",
    "helpAndSupportRedux",
    "createPostRedux",
    "reportRedux",
    "notificationsRedux",
    "events"
  ],
};

const reducer = combineReducers({
  Login: loginRedux.reducer,
  createPostRedux: createPostRedux.reducer,
  ProfileRedux: ProfileRedux.reducer,
  CreateProjectRedux: createProjectRedux.reducer,
  HomeRedux: homeRedux.reducer,
  ExploreRedux: exploreRedux.reducer,
  dashboardRedux: dashboardRedux.reducer,
  projectMeetingRedux: projectMeetingRedux.reducer,
  blogsRedux: blogsRedux.reducer,
  toasterRedux: ToasterRedux.reducer,
  commentRedux: CommentRedux.reducer,
  chatRedux: chatRedux.reducer,
  helpAndSupportRedux: helpAndSupportRedux.reducer,
  recommendationRedux: recommendationRedux.reducer,
  notificationsRedux: notificationsRedux.reducer,
  reportRedux: reportRedux.reducer,
  events: eventsRedux.reducer
});

const persistReducers: any = persistReducer(persistConfig, reducer);

export default () => {
  const middlewares: any = [];

  const middleware = createSagaMiddleware();
  middlewares.push(middleware);

  const sagaMiddleWare = () => middlewares;

  // use lower camelcase for all the reducer for example = blogsRedux: blogsRedux.reducer,

  const store = configureStore({
    // reducer: {
    //   Login: loginRedux.reducer,
    //   createPostRedux: createPostRedux.reducer,
    //   ProfileRedux: ProfileRedux.reducer,
    //   CreateProjectRedux: createProjectRedux.reducer,
    //   HomeRedux: homeRedux.reducer,
    //   ExploreRedux: exploreRedux.reducer,
    //   dashboardRedux: dashboardRedux.reducer,
    //   blogsRedux: blogsRedux.reducer,
    //   toasterRedux: ToasterRedux.reducer,
    //   commentRedux: CommentRedux.reducer,
    //   chatRedux: chatRedux.reducer,
    //   helpAndSupportRedux: helpAndSupportRedux.reducer,
    // },
    reducer: persistReducers,
    middleware: sagaMiddleWare,
  });

  middleware.run(rootSaga);

  return {
    store,
    sagaMiddleWare,
  };
};
